import { path } from 'ramda';

import {
  EStatus,
  IOfferHistoryStatusCountItemSchema,
} from '../../../repositories/valuation-offer-history/entities/offer_history/OfferHistoryStatusCountItemSchema';

/**
 * Заголовок блока может меняться в зависимости от наличия или отсутствия снятых\активных объявлений
 * Если присутствуют только активные объявления, заголовок будет 'Объявления в этом доме'
 * В остальных кейсах, заголовок будет 'История объявлений в этом доме'
 * */
export const prepareBlockTitle = (statusFilters: IOfferHistoryStatusCountItemSchema[]) => {
  if (statusFilters.length < 2 && path([0, 'status'], statusFilters) === EStatus.Published) {
    return 'Объявления в этом доме';
  }

  return 'История объявлений в этом доме';
};
